import React, { useEffect, useState } from 'react';
import configData from '../../temp/config';
import Logo from '../ContentBlock/images/Huggies_huggon.png'

const HomeComponentData = (props) => {

  const [componentdata, setComponentdata] = useState({
    title:'',
    log:''
  })

  useEffect(() => {
    setComponentdata({
      title: props.fields.title.value,
      toplogo: props.fields.topLogo.value.src
    })
  },[])

  return (      
    <header>
      <div className="brandlogo">
        <img src={componentdata.toplogo !== undefined ? `${configData.sitecoreApiHost}${componentdata.toplogo}` : Logo} alt="Huggies" className="logo" />
      </div>      
      <h1>{componentdata.title}</h1>
    </header>
  )
}

export default HomeComponentData;
